import pythonApiClient from './pythonBaseApi';

const reporteHistorialHuespedApi = {
  consultar: async (proyectoId, dni = '') => {
    const params = {};
    if (dni && String(dni).trim()) {
      params.dni = String(dni).trim();
    }
    const response = await pythonApiClient.get(
      '/reportes/hoteleria/historial-huesped/',
      {
        params,
        headers: { 'X-Proyecto-ID': proyectoId },
      }
    );
    return response.data;
  },
};

export default reporteHistorialHuespedApi;
